import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import PDFMerger from "pdf-merger-js/browser";
import { submitPesticideReport } from "../../../../../actions/chemistry";
import { checkReadyReports, runQCApiPost } from "../../../../../actions/sendReports";
import { uploadFileToS3, getFileFromS3 } from "../../../../../utils/helpers";
import { s3AutomationPrivate } from "../../../../../utils/aws";
import "./ChemPesticidePreview.css";

function ChemPesticidePreview({
  sampleDetail,
  latestPesticideData,
  pdfModalData,
  handleClosePreview,
}) {
  const [modalData, setPdfModalData] = useState(pdfModalData);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPdfModalData(pdfModalData);
  }, [pdfModalData]);

  /**
   * Merge the current pesticide PDF and the attachment pdf
   */
  const mergePdf = async () => {
    const { pdf, pesticides_attachment } = modalData;
    if (!pesticides_attachment) {
      return pdf;
    }
    let key = "media/batch_reports/metadata/Pesticides Attachment.pdf";
    if (sampleDetail.test_name === "Pesticides-USP") {
      key = "media/batch_reports/metadata/Genista USP Pesticides 032320.pdf";
    }

    const { blob: referencePdf, success } = await getFileFromS3(key, s3AutomationPrivate);
    if (!success) {
      return null;
    }
    const merger = new PDFMerger();
    await merger.add(pdf);
    await merger.add(referencePdf);
    const mergedPdf = await merger.saveAsBlob();
    return mergedPdf;
  };

  const handleSubmitReport = async () => {
    const {
      report_name,
      report_id,
      genista_id,
      workorder_id,
      user_id,
      test_name,
      report_date,
      received_date,
    } = modalData;
    if (moment(report_date, "MM/DD/YYYY") < moment(received_date, "MM/DD/YYYY")) {
      toast.error("Report Date should not be older than the Received Date");
      return;
    }
    setLoading(true);
    const fileName = report_name;
    const mergedPdf = await mergePdf();
    if (!mergedPdf) {
      toast.error("Failed to merge PDF");
      setLoading(false);
      return;
    }
    const s3Key = `media/batch_reports/available/${fileName}`;
    const uploadTime = moment().tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm:ss.SSS");
    const s3Payload = {
      file: mergedPdf,
      key: s3Key,
    };
    const { success: uploadSuccess, path } = await uploadFileToS3(s3Payload, s3AutomationPrivate);
    /** send the path and the mrl data to backend */
    if (uploadSuccess) {
      const payload = {
        report_id,
        genista_id,
        workorder_id,
        user_id,
        test_name,
        result: latestPesticideData,
        path: `${path}/${uploadTime}`,
      };
      const { success: submitSuccess, message } = await submitPesticideReport(payload);
      if (submitSuccess) {
        toast.success(message);
        runQCApiPost({ rerun: false, workorder_id_list: [{ wo_id: workorder_id }] });
        checkReadyReports();
        handleClosePreview(true);
      } else {
        toast.error(message);
        setLoading(false);
      }
    } else {
      toast.error("Failed to upload Report to S3");
      setLoading(false);
    }
  };

  return (
    <Modal
      title=""
      open={modalData.open}
      maskClosable={false}
      closable={false}
      footer={false}
      destroyOnClose
      centered
      className="ChemPesticidePreview"
    >
      {modalData.pdfUrl && <object className="ChemPesticidePreviewObject" data={modalData.pdfUrl + "#toolbar=0"} aria-label=""></object>} {/*eslint-disable-line */}
      <div className="ChemPesticidePreview__BtnDiv">
        <Button
          onClick={() => handleClosePreview()}
          disabled={loading}
        >
          Close
        </Button>
        <Button
          type="primary"
          onClick={() => handleSubmitReport()}
          loading={loading}
        >
          Generate Report
        </Button>
      </div>
    </Modal>
  );
}

export default ChemPesticidePreview;
